import type { FuelPlanRoute } from "./api";

interface RouteSelectorProps {
    routes: FuelPlanRoute[];
    selectedIndex: number;
    onChange: (index: number) => void;
}

// Route selection dropdown for the left panel (Pro version only)
const RouteSelector = ({ routes, selectedIndex, onChange }: RouteSelectorProps) => {
    if (!Array.isArray(routes) || !routes) return null;

    return (
        <div className="px-3 pt-2 pb-2 border-b border-gray-200 bg-gray-50">
            <label className="block text-xs font-medium text-gray-700 mb-1">Route Details:</label>
            <div className="relative">
                <select
                    className="appearance-none block w-full pl-2 pr-7 py-1.5 text-xs font-medium border border-gray-300 rounded shadow-sm focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 bg-white transition-colors"
                    value={selectedIndex}
                    onChange={(e) => {
                        console.log(`selected index: ${e.target.value}`);
                        onChange(parseInt(e.target.value));
                    }}
                >
                    {routes.map((route, idx) => {
                        // Get route name based on ranking
                        let routeName = route.routeType || `Rank ${route.optimalRanking || idx + 1}`;
                        if (route.optimalRanking === 1) routeName = "Rank One";
                        else if (route.optimalRanking === 2) routeName = "Rank Two";
                        else if (route.optimalRanking === 3) routeName = "Rank Three";

                        return (
                            <option key={`route-option-${idx}`} value={idx}>
                                {routeName}
                            </option>
                        );
                    })}
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center px-1.5 pointer-events-none">
                    <svg className="h-3 w-3 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                        <path
                            fillRule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clipRule="evenodd"
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default RouteSelector;
